import { X } from "lucide-react";
import { useEffect } from "react";

export default function Modal({ open, onClose, title, children, size = "md" }) {
    useEffect(() => {
        function onKey(e) { if (e.key === "Escape") onClose?.(); }
        if (open) document.addEventListener("keydown", onKey);
        return () => document.removeEventListener("keydown", onKey);
    }, [open, onClose]);

    if (!open) return null;

    const sizeClass = size === "lg" ? "max-w-3xl" : size === "sm" ? "max-w-md" : "max-w-xl";

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-4" data-testid="admin-modal">
            <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
            <div className={`relative w-full ${sizeClass} bg-white rounded-2xl shadow-2xl border border-border max-h-[90vh] flex flex-col`}>
                <div className="flex items-center justify-between px-6 py-4 border-b border-border">
                    <h2 className="font-heading text-lg font-bold">{title}</h2>
                    <button onClick={onClose} className="text-muted-foreground hover:text-primary" aria-label="Fechar">
                        <X className="h-5 w-5" />
                    </button>
                </div>
                <div className="px-6 py-5 overflow-y-auto">{children}</div>
            </div>
        </div>
    );
}
